import { useEffect, useState } from 'react'
import { REPOSITORY } from '../../../../../api/repository/Repository'
import { useLoadingContext } from '../../../../../utils/hooks/Context/LoadingContext'

const headers = [
  { label: 'Tarjeta', value: 'Tarjeta' },
  { label: 'Monto', value: 'Monto' },
  { label: 'Nombre', value: 'Nombre' },
  { label: 'Sucursal', value: 'Sucursal' },
  { label: 'Nombre Tarjeta', value: 'NombreTarjeta' },
]

export default function useNoNominativeFile() {
  const [noNominativeData, setNoNominativeData] = useState()
  const { handleOpen: handleLoadingNN, handleClose: handleCLoseLoadingNN } =
    useLoadingContext()

  const handleGetNoNominative = async () => {
    handleLoadingNN()
    await REPOSITORY.wsEmpresa.refills
      .refillNoNominativeDocument()
      .then((res) => {
        setNoNominativeData(res.data)
      })
      .catch((error) => {
        console.error(error)
        setNoNominativeData([])
      })
    handleCLoseLoadingNN()
  }

  useEffect(() => {
    handleGetNoNominative()
  }, [])

  return {
    noNominativeData,
    headers,
  }
}
